/* ============================================================================
   pltx2-lang-modal.js — open/close + focus trap + language auto-detect.
   Markup: snippets/pltx2-lang-modal.liquid   Styles: pltx2-lang-modal.css

   Submitting is deliberately Shopify's own {% form 'localization' %}: the
   radios (name="language_code") are UI only, and the chosen code is copied
   into the form's hidden locale_code field before submit. Shopify's form tag
   supplies form_type / _method / return_to, so the shopper lands back on the
   same page in the new locale.

   Nothing here ever redirects on its own. Auto-detect only OFFERS a switch —
   a silent redirect breaks the back button and overrides shoppers who chose a
   language on purpose. The answer (switch or dismiss) is remembered for a
   year in the pltx2_lang cookie so the bar cannot nag twice.
   ========================================================================== */

(function () {
  'use strict';

  var COOKIE = 'pltx2_lang';
  var COOKIE_DAYS = 365;

  var modal = document.getElementById('PltxLangModal');
  if (!modal) return;

  var dialog = modal.querySelector('.pltx2-langmodal__dialog');
  var form = document.getElementById('PltxLangForm');
  var localeField = form ? form.querySelector('input[name="locale_code"]') : null;

  var opener = null;
  var scrollPad = 0;
  var isOpen = false;

  /* ── cookies ───────────────────────────────────────────────────────────── */

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; expires=' +
      expires +
      '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      var eq = parts[i].indexOf('=');
      if (eq > -1 && parts[i].slice(0, eq) === name) {
        return decodeURIComponent(parts[i].slice(eq + 1));
      }
    }
    return '';
  }

  /* ── scroll lock ───────────────────────────────────────────────────────── */

  function lockScroll() {
    scrollPad = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollPad > 0) document.body.style.paddingInlineEnd = scrollPad + 'px';
  }

  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.paddingInlineEnd = '';
  }

  /* ── focus trap ────────────────────────────────────────────────────────── */

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusables() {
    if (!dialog) return [];
    return Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function trapTab(event) {
    var items = focusables();
    if (!items.length) {
      event.preventDefault();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function onKeydown(event) {
    if (!isOpen) return;
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      close();
    } else if (event.key === 'Tab') {
      trapTab(event);
    }
  }

  /* ── open / close ──────────────────────────────────────────────────────── */

  function open(trigger) {
    if (isOpen) return;
    opener = trigger || document.querySelector('[data-pltx-lang-open]');
    modal.hidden = false;
    isOpen = true;
    lockScroll();
    if (opener) opener.setAttribute('aria-expanded', 'true');

    var checked = form ? form.querySelector('input[name="language_code"]:checked') : null;
    var target = checked || focusables()[0];
    if (target) target.focus();
  }

  function close() {
    if (!isOpen) return;
    modal.hidden = true;
    isOpen = false;
    unlockScroll();
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus();
      opener = null;
    }
  }

  /* ── choosing a language ───────────────────────────────────────────────── */

  function chooseLocale(code) {
    if (!form || !localeField || !code) return;
    setCookie(COOKIE, code, COOKIE_DAYS);
    localeField.value = code;
    unlockScroll();
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  /* ── wiring ────────────────────────────────────────────────────────────── */

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    var trigger = event.target.closest('[data-pltx-lang-open]');
    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }
    if (isOpen && event.target.closest('[data-pltx-lang-close]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', onKeydown);

  if (form) {
    // Selecting a language submits immediately — no separate Save button.
    form.addEventListener('change', function (event) {
      var radio = event.target.closest('input[name="language_code"]');
      if (radio) chooseLocale(radio.value);
    });
  }

  /* ── auto-detect ───────────────────────────────────────────────────────── */

  function primaryTag(code) {
    return String(code || '')
      .split('-')[0]
      .toLowerCase();
  }

  function initAutodetect() {
    var bar = document.getElementById('PltxLangDetect');
    var blob = document.getElementById('PltxLangData');
    if (!bar || !blob) return;

    var data;
    try {
      data = JSON.parse(blob.textContent);
    } catch (err) {
      return;
    }
    if (!data || !data.autodetect || !data.languages || data.languages.length < 2) return;

    // Already answered once — never ask again.
    if (getCookie(COOKIE)) return;

    var currentTag = primaryTag(data.current);
    var preferred =
      navigator.languages && navigator.languages.length
        ? navigator.languages
        : [navigator.language || ''];

    var match = null;
    for (var i = 0; i < preferred.length; i++) {
      var tag = primaryTag(preferred[i]);
      if (!tag) continue;
      // The shopper's strongest preference we can honour is the locale they are
      // already on — stop here rather than offering a weaker preference.
      if (tag === currentTag) return;
      for (var j = 0; j < data.languages.length; j++) {
        if (primaryTag(data.languages[j].code) === tag) {
          match = data.languages[j];
          break;
        }
      }
      if (match) break;
    }
    if (!match || match.code === data.current) return;

    var textEl = bar.querySelector('[data-pltx-detect-text]');
    var goEl = bar.querySelector('[data-pltx-detect-switch]');
    var dismissEl = bar.querySelector('[data-pltx-detect-dismiss]');

    if (textEl) {
      textEl.textContent = (bar.getAttribute('data-tpl-text') || '').replace('%LANG%', match.endonym);
    }
    if (goEl) {
      goEl.textContent = (bar.getAttribute('data-tpl-switch') || '').replace('%LANG%', match.endonym);
      goEl.setAttribute('lang', match.code);
      goEl.setAttribute('dir', match.rtl ? 'rtl' : 'ltr');
      goEl.addEventListener('click', function () {
        chooseLocale(match.code);
      });
    }
    if (dismissEl) {
      dismissEl.addEventListener('click', function () {
        // Record the current locale as the shopper's choice, so dismissing is
        // as sticky as switching.
        setCookie(COOKIE, data.current, COOKIE_DAYS);
        bar.hidden = true;
      });
    }

    bar.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutodetect);
  } else {
    initAutodetect();
  }
})();
